import { AutomationEventTypes } from '@tokeet-frontend/automations'

export const userExtraNotificationMessages = {
  [AutomationEventTypes.ExtraCreated]: {
    subject: 'New Extra Created – *|GUEST:NAME|*',
    message: `
      Hi Team,

      A new extra has been created for this booking. Please review and take any necessary actions.

      Booking Details:
      Guest Name: *|GUEST:NAME|*
      Extra Amount: *|EXTRA:AMOUNT|*
      Description: *|EXTRA:DESCRIPTION|*
      `,
  },
  [AutomationEventTypes.ExtraPaid]: {
    subject: 'Extra Marked as Paid – *|GUEST:NAME|*',
    message: `
      Hi Team,

      The extra for this booking has been marked as paid. Please update records accordingly.

      Booking Details:
      Guest Name: *|GUEST:NAME|*
      Extra Amount: *|EXTRA:AMOUNT|*
      Description: *|EXTRA:DESCRIPTION|*
      `,
  },
  [AutomationEventTypes.ExtraDeleted]: {
    subject: 'Extra Deleted – *|GUEST:NAME|*',
    message: `
      Hi Team,

      The extra for this booking has been deleted. Please update records accordingly.
      Booking Details:
      Guest Name: *|GUEST:NAME|*
      Extra Amount: *|EXTRA:AMOUNT|*
      Description: *|EXTRA:DESCRIPTION|*
      `,
  },
}

export const guestExtraNotificationMessages = {
  [AutomationEventTypes.ExtraCreated]: {
    subject: 'Additional Charge for Your Stay at *|RENTAL:NAME|*',
    message: `
      Dear *|GUEST:NAME|*,

      We’d like to inform you that an additional charge has been added to your booking at *|RENTAL:NAME|*.

      Extra Details:
      Amount: *|EXTRA:AMOUNT|*
      Description: *|EXTRA:DESCRIPTION|*

      If you have any questions or need further clarification, please feel free to reach out to us at *|RENTAL:PHONE|*.
    `,
  },
}
